import { environment } from '../../environments/environment';

/**
 * Get Google Maps API Key with fallback priority:
 * 1. Environment variable REACT_APP_GOOGLE_MAPS_API_KEY
 * 2. Environment config googleMapsApiKey
 * 3. Hardcoded fallback key
 */
export const getGoogleMapsApiKey = () => {
  const envVarKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const configKey = environment.googleMapsApiKey;
  const fallbackKey = 'AIzaSyCjXKmwz0IWhznLipLL8OOqJs579HNYvqw';

  // Priority: env variable > config > fallback
  const key = envVarKey || configKey || fallbackKey;
  return key;
};

/**
 * Get Google Maps API Key for bootstrap URLs (GoogleMapReact)
 */
export const getGoogleMapsBootstrapConfig = () => {
  return {
    key: getGoogleMapsApiKey(),
  };
};

/**
 * Generate Google Maps script URL with proper API key
 */
export const getGoogleMapsScriptUrl = (libraries = ['places']) => {
  const key = getGoogleMapsApiKey();
  const librariesParam =
    libraries.length > 0 ? `&libraries=${libraries.join(',')}` : '';
  return `https://maps.googleapis.com/maps/api/js?key=${key}${librariesParam}`;
};

/**
 * Dynamically load Google Maps script with environment-based API key
 * This replaces the hardcoded script in index.html
 */
export const loadGoogleMapsScript = (libraries = ['places']) => {
  return new Promise((resolve, reject) => {
    // Check if Google Maps is already loaded
    if (window.google && window.google.maps) {
     
      resolve(window.google);
      return;
    }

    // Check if script is already being loaded
    const existingScript = document.querySelector(
      'script[src*="maps.googleapis.com"]'
    );
    if (existingScript) {
     
      existingScript.addEventListener('load', () => resolve(window.google));
      existingScript.addEventListener('error', reject);
      return;
    }


    const script = document.createElement('script');
    script.src = getGoogleMapsScriptUrl(libraries);
    script.async = true;
    script.defer = true;

    script.onload = () => {
    
      resolve(window.google);
    };

    script.onerror = (error) => {
      console.error('🗺️ Failed to load Google Maps script:', error);
      reject(error);
    };

    document.head.appendChild(script);
  });
};
